import React, { useEffect, useState } from "react";
import ExtensionCard from "app/popleads/components/ui-kit/ExtensionCard";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import { POPUP_CONTENTS } from "../utils/constants";
import { useExtensionContext } from "../ExtensionContext";
import ButtonWithLabel from "app/popleads/components/ui-kit/ButtonWithLabel";
import styled from "styled-components";
import { toast } from "react-toastify";
import { colors } from "app/popleads/components/ui-kit/colors";
import { StyledCardContent } from "./common/styled";
import ExtensionNote from "./ExtensionNote";

const TitleContainer = styled.div`
    display: flex;
    align-items: center;
`;

const TitleWithAction = styled.div`
    cursor: pointer;
    &:hover {
        color: ${colors.primary[900]};
        text-decoration: underline;
    }
`;

const ExtensionNoteCard = ({ showFilesAndAttachments, setShowFilesAndAttachments }) => {
    const { setState, profileNotesRefetch, noteList, profileNotesLoading, profile, popit } = useExtensionContext();
    const [noteListArr, setNoteListArr] = useState([]);

    const refetchProfileNotes = (rowsPerPage) => {
        profileNotesRefetch({ rowsPerPage: rowsPerPage });
    };

    const handleAttachmentsClick = () => {
        if (popit) {
            toast.warning("You need to POP the profile first.");
        } else {
            setState({ popupContent: POPUP_CONTENTS.NOTES });
            setShowFilesAndAttachments(true);
            refetchProfileNotes(100);
        }
    };

    const handleNotesOpen = () => {
        if (popit) {
            toast.warning("You need to POP the profile first.");
        } else {
            setState({ popupContent: POPUP_CONTENTS.NOTES });
            setShowFilesAndAttachments(false);
        }
    };

    useEffect(() => {
        if (noteList && noteList?.length > 0) {
            const newNoteList = noteList?.map((note) => {
                return {
                    id: note.id,
                    icon: note.tip === "otomatik" && (
                        <StyledCardContent
                            variant={"warning"}
                            className="material-symbols-outlined"
                            style={{ fontSize: "22px", fontWeight: "300" }}
                        >
                            sync_problem
                        </StyledCardContent>
                    ),
                    content: <ExtensionNote variant="profile" note={note} />,
                };
            });

            setNoteListArr(newNoteList);
        }
    }, [noteList]);

    return (
        <ExtensionCard
            variant={"notes-card"}
            button={
                <ButtonWithText
                    icon="add"
                    onClick={() => handleNotesOpen()}
                    iconType="material"
                    variant="primary"
                    buttonStyle="default"
                    size="circle"
                />
            }
            cardTitle={
                <TitleContainer>
                    <TitleWithAction onClick={() => handleNotesOpen()}>Notes</TitleWithAction>

                    <ButtonWithLabel
                        icon="attach_file"
                        iconType="material"
                        variant="primary"
                        buttonStyle="borderless"
                        label={`${profile?.attachments?.length || 0} Attached Files`}
                        style={{ fontSize: "12px" }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleAttachmentsClick();
                        }}
                        hover={false}
                    />
                </TitleContainer>
            }
            cardItems={noteListArr}
            viewMoreOnClick={() => handleNotesOpen()}
            errorDescription={profileNotesLoading ? "Loading notes..." : "Click the + to create a note."}
        />
    );
};

export default ExtensionNoteCard;
